import React, { Component } from 'react'
import classNames from 'classnames/bind'
import * as data from './data'
import Content from './Content'
import styles from './s.module.css'

let cx = classNames.bind(styles)

export default class MainTreeItem extends Component {
  constructor (props) {
    super(props)
    this.state = {
      on: false
    }
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick () {
    this.setState(prevState => (
      {
        on: !prevState.on
      }
    ))
  }

  render () {
    const { mainIndex, index } = this.props
    const keyIndex = `${mainIndex}${index}`
    const cls = cx('subTreeItemLabel', {
      on: this.state.on
    })
    return (
      <li className={styles.subTreeItem} >
        <div className={cls} onClick={this.handleClick} >{data.labels[index]}</div>
        {this.state.on ? <Content index={keyIndex} od={this.props.od} /> : null}
      </li>
    )
  }
}

// MainTreeItem.propTypes = {
//   mainIndex: PropTypes.number,
//   index: PropTypes.number,
//   onClick: PropTypes.func,
//   od: PropTypes.string
// }
